import axios from "axios";

class SMESSISkillMappingService {

    static BASE_URL = process.env.REACT_APP_BASE_URL2;

    static async addMyCompetencyProficiencySkill(payload) {
        try {
          const response = await axios.post(`${SMESSISkillMappingService.BASE_URL}/api/sme-skills/addSkill`, payload);
          return response.data; // Directly return the response data
        } catch (error) {
            console.error("API Error:", error.response || error.message);
            throw new Error(
            error.response?.data?.message || "Failed to communicate with the server."
            );
        }
      }

      
    static async updateMyCompetencyProficiencySkill(payload) {
        try {
            const response = await axios.put(`${SMESSISkillMappingService.BASE_URL}/api/sme-skills/updateSkill`, payload);
            return response.data;
        } catch (error) {
            console.error("Update Skill Error:", error.response || error.message);
            throw new Error(error.response?.data?.message || "Failed to update skill.");
        }
    }
      
    static async deleteMyCompetencyProficiencySkill(skillId) {
        try {
             axios.delete(`${SMESSISkillMappingService.BASE_URL}/api/sme-skills/deleteSkill/${skillId}`);
        } catch (error) {
            console.error("Delete Skill Error:", error.response || error.message);
            throw new Error(error.response?.data?.message || "Failed to delete skill.");
        }
    }

    static async getAllSkillsByUserAndSkillType(userId, skillType) {
        try {
            const response = await axios.get(`${SMESSISkillMappingService.BASE_URL}/api/sme-skills/retrieveAllSkillsBySkillType/${userId}/${skillType}`);
            return response.data;
        } catch (error) {
            console.error("Retrieve Skills Error:", error.response || error.message);
            throw new Error(error.response?.data?.message || "Failed to fetch skills.");
        }
    }

    static async searchSSISkillNames(query) {
        try {
            const response = await axios.get(`${SMESSISkillMappingService.BASE_URL}/api/sme-skills/retrieveAllSSISkillsNamesBasedOnQuery?query=${encodeURIComponent(query)}`);
            return response.data;
        } catch (error) {
            console.error("Retrieve Skills Error:", error.response || error.message);
            throw new Error(error.response?.data?.message || "Failed to fetch skills.");
        }
    }

}

export default SMESSISkillMappingService;